import React, { Component } from 'react';

import LeafletMapProfile from '../b-LeafletMap/LeafletMapProfile';

import Sources from '../f-Utilities/Sources'

class PopulationProfile extends React.Component {
  constructor(props) {
    super(props);

    var communes = this.props.territory.communes;
    var all_residential_areas = [];
    communes.map((c) => all_residential_areas = all_residential_areas.concat(c.residential_areas))

    communes.map((c) => c["employed_prop"] = Math.round(c.status.employed/c.population*100));
    communes.map((c) => c["retired_prop"] = Math.round(c.status.retired/c.population*100));
    communes.map((c) => c["scholars_prop"] = Math.round((c.status.scholars_11_14+
                                                       c.status.scholars_15_17+
                                                       c.status.scholars_18+
                                                       c.status.scholars_2_5+
                                                       c.status.scholars_6_10)/c.population*100));
    communes.map((c) => c["unemployed_prop"] = Math.round(c.status.unemployed/c.population*100));

    this.state = {
      territory: props.territory,
      communes: communes,
      residential_areas: all_residential_areas,
      selected: "motorisation_rate",
      masses: communes.map((c)=>c["motorisation_rate"]),
      labels: communes.map((c) => c.name + " - " + c["motorisation_rate"] + "%"),
      legend_label: "(taux de motorisation des ménages - %)",
      map_legend: null
    };
  }

  displayCategory = (cat, suffix, legend_label) => {
      var masses = this.state.communes.map((c)=>c[cat])
      var labels = this.state.communes.map((c, i) => c.name + " - " + masses[i] + suffix);

      this.setState({
        selected: cat,
        masses: masses,
        labels: labels,
        legend_label: legend_label,
      })
  }

  componentDidMount(){
    this.displayCategory("motorisation_rate", "%", "(taux de motorisation des ménages - %)")
  }

  render() {
    var communes = this.props.territory.communes;
    var all_residential_areas = [];
    communes.map((c) => all_residential_areas = all_residential_areas.concat(c.residential_areas))

    communes.map((c) => c["employed_prop"] = Math.round(c.status.employed/c.population*100));
    communes.map((c) => c["retired_prop"] = Math.round(c.status.retired/c.population*100));
    communes.map((c) => c["scholars_prop"] = Math.round((c.status.scholars_11_14+
                                                       c.status.scholars_15_17+
                                                       c.status.scholars_18+
                                                       c.status.scholars_2_5+
                                                       c.status.scholars_6_10)/c.population*100));
    communes.map((c) => c["unemployed_prop"] = Math.round(c.status.unemployed/c.population*100));

    communes.map((c) => c["-18_prop"] = Math.round(c.pop_age["-18"]/c.population*100));
    communes.map((c) => c["+65_prop"] = Math.round(c.pop_age["+65"]/c.population*100));

    var csps = {};
    Object.keys(communes[0].csp).filter((key)=> key != "csp8" && key != "total15+").
    map((key) => csps[key] = communes[0].csp[key]["label"].toLowerCase())
    Object.keys(csps).map((csp_name) =>
        communes.map((c) => c[csp_name + "_prop"] = Math.round(c.csp[csp_name]["value"]/c.csp["total15+"]["value"]*100))
      )


    return(
          <div className="row content mt-5 mb-5">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">profil de la population</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 line-border">
                    <p
                    className={this.state.selected === "motorisation_rate" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "motorisation_rate", "%", "(taux de motorisation des ménages - %)")}>taux de motorisation des ménages</p>


                  <p className="mb-2 mt-4" id="population"><i>répartition par âge :</i></p>

                  <p
                  className={this.state.selected === "-18_prop" ?
                    "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                     onClick={this.displayCategory.bind(this, "-18_prop", "%", "(part des -18 ans - %)")}>- part des moins de 18 ans </p>
                   <p
                   className={this.state.selected === "+65_prop" ?
                     "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                      onClick={this.displayCategory.bind(this, "+65_prop", "%", "(part des +65 ans - %)")}>- part des plus de 65 ans </p>


                    <p className="mb-2 mt-4" id="population"><i>répartition par statut :</i></p>

                    <p
                    className={this.state.selected === "employed_prop" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                       onClick={this.displayCategory.bind(this, "employed_prop", "%", "(part d'actifs - %)")}>- actifs & actives </p>
                     <p
                     className={this.state.selected === "retired_prop" ?
                       "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                        onClick={this.displayCategory.bind(this, "retired_prop", "%", "(part des retraités - %)")}>- à la retraite </p>
                     <p
                     className={this.state.selected === "scholars_prop" ?
                       "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                        onClick={this.displayCategory.bind(this, "scholars_prop", "%", "(part d'élèves - %)")}>- scolaires </p>
                      <p
                      className={this.state.selected === "unemployed_prop" ?
                        "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                         onClick={this.displayCategory.bind(this, "unemployed_prop", "%", "(part des personnes au chômage - %)")}>- au chômage </p>


                     <p className="mb-2 mt-4" id="population"><i>répartition par CSP des +15 ans :</i></p>

                     {Object.keys(csps).map((csp)=>
                        <p
                        className={this.state.selected === csp + "_prop" ?
                          "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                           onClick={this.displayCategory.bind(this, csp + "_prop", "%", "(part des +15 ans - %)")}>- {csps[csp]} </p>
                     )}

                  </div>

                </div>
            </div>

            <div className="col-9">
                <LeafletMapProfile residential_areas={this.state.residential_areas}
                                   communes={this.state.communes}
                                   masses={this.state.masses}
                                   labels={this.state.labels}
                                   selected={this.state.selected}
                                   legend_label={this.state.legend_label}
                                   id="population_profile_map"/>
               <div className="row mt-1">
                 <div className="col-10">
                  <Sources sources={this.props.territory.sources}
                         concerned={["dossier_complet", "pop_age"]}/>
                 </div>
               </div>

            </div>

          </div>
    )
  }
}

export default PopulationProfile;
